import { seaWaybillLogApis } from '@apis/seaWaybillLogApis';
import { useQuery } from '@hooks/useQuery';

export const useSeaWaybillLog = (id?: number) => {
  return useQuery([`/dashboard/sea-waybill-log/${id}/`], () =>
    id !== undefined
      ? seaWaybillLogApis
          .get('/dashboard/sea-waybill-log/{id}/', { path: { id } })
          .then((r) => r[200]!)
      : undefined,
  );
};
